import WondeAdapter from './base';

export default class School extends WondeAdapter {
  modelNamePlural = 'schools';
}
